export default "__VITE_ASSET__BFSu3eMs__"